import { useTranslation } from 'react-i18next';

// Routes configuration for different languages
export const ROUTES = {
  en: {
    auth: {
      login: '/auth/login',
      signup: '/auth/signup',
      forgotPassword: '/auth/forgot-password'
    }
  },
  fr: {
    auth: {
      login: '/auth/connexion',
      signup: '/auth/inscription',
      forgotPassword: '/auth/mot-de-passe-oublie'
    }
  }
} as const;

// Get localized route
export const getLocalizedRoute = (route: string, language: string = 'en'): string => {
  const lang = language.split('-')[0] as keyof typeof ROUTES;
  
  // Map English routes to localized routes
  const routeMap: Record<string, string> = {
    '/auth/login': ROUTES[lang]?.auth?.login || ROUTES.en.auth.login,
    '/auth/signup': ROUTES[lang]?.auth?.signup || ROUTES.en.auth.signup,
    '/auth/forgot-password': ROUTES[lang]?.auth?.forgotPassword || ROUTES.en.auth.forgotPassword,
  };

  return routeMap[route] || route;
};

// Get English route from localized route
export const getEnglishRoute = (localizedRoute: string, language: string = 'en'): string => {
  const lang = language.split('-')[0] as keyof typeof ROUTES;
  
  if (lang === 'en') return localizedRoute;
  
  // Reverse mapping for French routes
  const reverseMap: Record<string, string> = {
    '/auth/connexion': '/auth/login',
    '/auth/inscription': '/auth/signup',
    '/auth/mot-de-passe-oublie': '/auth/forgot-password',
  };

  return reverseMap[localizedRoute] || localizedRoute;
};

// Hook to get localized routes
export const useLocalizedRoutes = () => {
  const { i18n } = useTranslation();
  const language = i18n.language;

  return {
    auth: {
      login: getLocalizedRoute('/auth/login', language),
      signup: getLocalizedRoute('/auth/signup', language),
      forgotPassword: getLocalizedRoute('/auth/forgot-password', language),
    }
  };
}; 